var map = {
	"./dataEight.svg": 471,
	"./dataFive.svg": 2143,
	"./dataFour.svg": 7085,
	"./dataOne.svg": 6319,
	"./dataSeven.svg": 9068,
	"./dataSix.svg": 2378,
	"./dataThree.svg": 2673,
	"./dataTwo.svg": 1801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;